import { Form } from "react-bootstrap";
// import PageLoading from "../../img/Document scan.gif"

export const NoDataFoundTable = ({ MSG }) => (
  <div className={`hstack justify-content-center align-items-cente h-100`} style={{fontSize: 12, userSelect: "none"}}>
    <Form.Label className="fw-bold text-muted">{MSG}</Form.Label>
  </div>
);

// export const PageLoader = () => (
//   <div className="hstack justify-content-center h-100">
//     <img src={PageLoading} alt="Page Loader"/>
//   </div>
// );
